// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles__footer___TC8sw","done":"styles__done___Ff1jz"};